export const QUERY_PRODUCTS = 'products';
export const QUERY_NOTIFICATIONS = 'notifications';
export const QUERY_CLIENT_NOTIFICATIONS = 'clientNotifications';
export const QUERY_CLIENTS = 'clients';
export const QUERY_PARTNERS = 'partners';